import http from '../utils/http';

export default {

  async getAllSurveyContents() {
    try {
      const { results } = await http.post('/survey/list', {
        search_type: 'T',
        category_cd: '',
        category_name: '',
        question: '',
        pack_cd: '',
        useyn: '',
      });
      const r = {};

      // do something with results;
      results.forEach((element) => {
        const temp = [];
        const keyName = element.recm_category;
        element.survey_detail.forEach((n) => {
          temp.push({
            id: keyName + n.sub_seq,
            question: n.question,
            checked: null,
          });
        });
        const ob = {
          uncheckedBtnCnt: element.survey_detail.length,
          recmPacks: element.recm_pack_cd,
          questions: temp,
        };
        r[keyName] = ob;
      });

      return r;
    } catch (e) {
      return [];
    }
  },

};



// WEBPACK FOOTER //
// ./src/apis/survey.js